var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-notifications-view',{attrs:{"loading":_vm.loading,"scroll":_vm.scroll,"notifications-list":_vm.notificationsList},on:{"next":_vm.getNextData}})}
var staticRenderFns = []

export { render, staticRenderFns }